import cn from './styles.module.scss';

export const SectionHeader = ({ children }: { children: React.ReactNode}) => {
  return (
    <div className={cn.sectionHeader}>
      {children}
    </div>
  )
}
